import { config } from '@skytech/config'
import { useQuery } from '@tanstack/react-query'
import ArrowRightCircleIcon from 'mdi-react/ArrowRightCircleIcon'
import { useSelector } from 'react-redux'

import authResources from '@/api/auth'
import queries from '@/api/queries'
import Button from '@/components/form/Button'
import { Translation } from '@/components/i18n/Translation'
import { getCustomerId } from '@/ducks/customerReducer'

import './tab-admin.scss'

const MANAGER_URL = `${config.MANAGER_URL}?token=:token`

const TabAdmin = () => {
  const customerId = useSelector(getCustomerId)
  const { refetch: fetchManagerToken } = useQuery(
    queries.managerToken(),
    () => authResources.getManagerToken(customerId),
    {
      enabled: false,
      onSuccess({ token }) {
        window.open(MANAGER_URL.replace(':token', token), '_blank')
      },
    }
  )

  return (
    <div className="tab-admin">
      <div className="button-wrapper">
        <Button onClick={fetchManagerToken}>
          <Translation id="Go to Manager" /> &nbsp; <ArrowRightCircleIcon />
        </Button>
      </div>
    </div>
  )
}

export default TabAdmin
